const BulkApprovalCheckbox = ({ isAllApproved, handleCheckboxChange }) => (
    <h6>
      <div className="form-check">
        <input
          className="form-check-input rounded-0 ms-0"
          type="checkbox"
          style={{ borderColor: "#ee5454" }}
          checked={isAllApproved}
          onChange={handleCheckboxChange}
        />
        <label
          className="form-check-label m-3"
          style={{
            color: "#ee5454",
            fontWeight: 200,
            fontFamily: "ui-monospace",
          }}
        >
          Do you want to approve whole order?
        </label>
      </div>
    </h6>
  );
  
  export default BulkApprovalCheckbox;